import React from 'react';

const areas = [
  { label: "Brisbane", url: "/commercial-plumber-brisbane", title: "Commercial plumber Brisbane" },
  { label: "South Brisbane", url: "/commercial-plumber-south-brisbane", title: "Commercial plumber South Brisbane" },
  { label: "Ipswich", url: "/commercial-plumber-ipswich", title: "Commercial plumber Ipswich" },
  { label: "Logan", url: "/commercial-plumber-logan", title: "Commercial plumber Logan" },
  { label: "Gold Coast", url: "/commercial-plumber-gold-coast", title: "Commercial plumber Gold Coast" },
  { label: "Sunshine Coast", url: "/commercial-plumber-sunshine-coast", title: "Commercial plumber Sunshine Coast" },
  { label: "Toowoomba", url: "/commercial-plumber-toowoomba", title: "Commercial plumber Toowoomba" },
  { label: "North Lakes", url: "/commercial-plumber-north-lakes", title: "Commercial plumber North Lakes" },
  { label: "Chermside", url: "/commercial-plumber-chermside", title: "Commercial plumber Chermside" },
  { label: "Caboolture", url: "/commercial-plumber-caboolture", title: "Commercial plumber Caboolture" },
  { label: "Redcliffe", url: "/commercial-plumber-redcliffe", title: "Commercial plumber Redcliffe" },
  { label: "Brendale", url: "/commercial-plumber-brendale", title: "Commercial plumber Brendale" },
  { label: "Springfield", url: "/commercial-plumber-springfield", title: "Commercial plumber Springfield" },
  { label: "Fortitude Valley", url: "/commercial-plumber-fortitude-valley", title: "Commercial plumber Fortitude Valley" },
  { label: "Moreton Bay", url: "/commercial-plumber-moreton-bay", title: "Commercial plumber Moreton Bay" },
];

export default function ServiceAreasSection() {
  return (
    <section className="py-16 md:py-24 bg-[#111111] relative overflow-hidden">
      {/* Subtle Grid Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(192, 192, 192, 0.3) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(192, 192, 192, 0.3) 1px, transparent 1px)`,
          backgroundSize: '60px 60px'
        }} />
      </div>
      
      <div className="max-w-7xl mx-auto px-5 sm:px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <p className="text-[#60a5fa] font-semibold tracking-widest uppercase mb-4 text-xs">Coverage</p>
            <h2 className="font-bold mb-6" style={{ fontSize: 'clamp(1.6rem, 5vw, 3rem)' }}>
              <span className="bg-gradient-to-r from-[#E8E8E8] via-[#C0C0C0] to-[#E8E8E8] bg-clip-text text-transparent">
                Servicing South East
              </span>
              <br />
              <span className="text-white">Queensland</span>
            </h2>
            <p className="text-gray-400 text-base md:text-lg mb-8">
              From the Sunshine Coast to the Gold Coast and everywhere in between, 
              we deliver commercial plumbing services 
              across the entire South East Queensland region.
            </p>
            
            {/* Areas Grid */}
            <div className="grid grid-cols-2 gap-4">
              {areas.map((area, index) => (
                <a
                  key={index}
                  href={area.url}
                  title={area.title}
                  className="flex items-center gap-3 text-gray-300 hover:text-[#60a5fa] transition-colors duration-200 group"
                >
                  <div className="w-2 h-2 bg-[#2563eb] rounded-full group-hover:bg-[#60a5fa] transition-colors duration-200 flex-shrink-0" />
                  <span className="font-medium hover:underline underline-offset-2">{area.label}</span>
                </a>
              ))}
            </div>
            <div className="mt-8 flex justify-center">
              <a
                href="/service-areas"
                className="inline-flex items-center gap-2 bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-semibold text-sm px-7 py-3 transition-all duration-300"
                style={{ borderRadius: '2px', boxShadow: '0 4px 14px rgba(37,99,235,0.35)' }}
              >
                View All Service Areas
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="relative w-full max-w-lg mx-auto mt-4 lg:mt-0">
            <div className="overflow-hidden border border-white/10" style={{ borderRadius: '4px' }}>
              <iframe
                title="Oliver & Sons Plumbing Service Area"
                width="100%"
                height="450"
                style={{ border: 0, display: 'block', filter: 'grayscale(20%) invert(90%) hue-rotate(180deg) brightness(0.85) contrast(0.9)' }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d574000!2d153.0251!3d-27.4698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f8!5e0!3m2!1sen!2sau!4v1700000000000!5m2!1sen!2sau"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
